import { useState } from "react";
import { api } from "@/api/client";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

/** Rolled-Up Wave, Part 1A (2026-10) — "Estimate calculator" on/off switch, shared by
 * PartnerDetail.jsx (agency) and Clients.jsx's ClientDetail (client). Backed by the Mongo-only
 * `estimator_enabled` field (no Notion property — see modules/partners.py / modules/clients.py,
 * same `patch_local_only` discipline as ClientPortalPmCard/pm_user_id), default true (missing
 * key = enabled). "On" = the agency/client can open the estimator; "Off" = every
 * /agency/estimator/* route 403s and the nav button/direct URL show a friendly message —
 * existing drafts/quotes are never affected either way. */
export const EstimatorEnabledToggle = ({ entity, recordId, initialEnabled }) => {
  const [enabled, setEnabled] = useState(initialEnabled !== false);
  const [saving, setSaving] = useState(false);

  const toggle = async (next) => {
    setSaving(true);
    try {
      await api.patch(`/v1/${entity}/${recordId}`, { estimator_enabled: next });
      setEnabled(next);
      toast.success(next ? "Estimate calculator enabled" : "Estimate calculator disabled");
    } catch {
      toast.error("Couldn't update the Estimate calculator setting");
    } finally { setSaving(false); }
  };

  return (
    <div className="flex items-center gap-2" data-testid={`estimator-enabled-toggle-${entity}-${recordId}`}>
      <Switch checked={enabled} disabled={saving} onCheckedChange={toggle} data-testid={`estimator-enabled-switch-${entity}-${recordId}`} />
      <span className="text-[11px] uppercase tracking-wider text-[#78716C]" data-testid={`estimator-enabled-label-${entity}-${recordId}`}>
        Estimate calculator — {enabled ? "On" : "Off"}
      </span>
    </div>
  );
};
